import React from 'react';

interface TimeRatioBarProps {
  waitTime: number;
  attentionTime: number;
  totalTime: number;
}

export const TimeRatioBar: React.FC<TimeRatioBarProps> = ({
  waitTime,
  attentionTime,
  totalTime,
}) => {
  const waitPercentage = totalTime > 0 ? (waitTime / totalTime) * 100 : 0;
  const attentionPercentage =
    totalTime > 0 ? (attentionTime / totalTime) * 100 : 0;

  return (
    <div className='mt-10 group cursor-default'>
      <div className='flex justify-between items-end text-[10px] font-black text-slate-400 mb-2.5 uppercase tracking-widest px-1'>
        <span>Distribución de Tiempos</span>
        <div className='flex gap-3'>
          <span className='flex items-center gap-1.5'>
            <div className='w-2 h-2 rounded-full bg-amber-400' />
            Espera: {waitPercentage.toFixed(0)}%
          </span>
          <span className='flex items-center gap-1.5'>
            <div className='w-2 h-2 rounded-full bg-emerald-400' />
            Atención: {attentionPercentage.toFixed(0)}%
          </span>
        </div>
      </div>

      <div className='flex h-5 rounded-full overflow-hidden w-full bg-slate-50 border border-slate-100 shadow-inner group-hover:scale-[1.01] transition-transform duration-500'>
        <div
          className='bg-gradient-to-r from-amber-400 to-orange-400 h-full transition-all duration-1000 ease-out flex items-center justify-center'
          style={{ width: `${waitPercentage}%` }}
        >
          {waitPercentage > 15 && (
            <div className='w-full h-full animate-pulse bg-white/10 opacity-50' />
          )}
        </div>
        <div
          className='bg-gradient-to-r from-emerald-400 to-teal-500 h-full transition-all duration-1000 ease-out border-l-2 border-white/40 flex items-center justify-center'
          style={{ width: `${attentionPercentage}%` }}
        >
          {attentionPercentage > 15 && (
            <div className='w-full h-full transition-opacity bg-white/10 opacity-50' />
          )}
        </div>
      </div>
    </div>
  );
};
